import React from 'react'
import PropTypes from 'prop-types'
import { Header } from './Header'
import { ItemsGrid } from 'LiveBoard/components/mobile/Items/ItemsGrid'
import { SkeletonTiles } from 'LiveBoard/components/mobile/shared/SkeletonTiles'
import isEmpty from 'lodash/isEmpty'

const SKELTON_TILES = 3

const Category = (props) => {
  const {
    items, itemIds, mostViewedItemId, themeColorHex, isLoading,
    hasMorePages, onNextPage, onItemClick, shouldFetchNextPage,
    gatingEnabled, showViews, showLikes, showItemDescription,
    showHomeCategory, categories, categoryIds,
    selectedCategoryId, onCategoryClick, getItemUrl
  } = props

  return (
    <div className="category-container">
      { selectedCategoryId && !isEmpty(categories) && (
        <Header
          categories={categories}
          categoryIds={categoryIds}
          selectedCategoryId={selectedCategoryId}
          onCategoryClick={onCategoryClick}
          themeColorHex={themeColorHex}
          showHomeCategory={showHomeCategory} />
      )}
      { isEmpty(items) ? (
            <SkeletonTiles numTiles={SKELTON_TILES} /> 
        ) : (
          <ItemsGrid
            items={items}
            itemIds={itemIds}
            mostViewedItemId={mostViewedItemId}
            themeColorHex={themeColorHex}
            isLoading={isLoading}
            hasMorePages={hasMorePages}
            onNextPage={onNextPage}
            onItemClick={onItemClick}
            shouldFetchNextPage={shouldFetchNextPage}
            gatingEnabled={gatingEnabled}
            showViews={showViews}
            showLikes={showLikes}
            showItemDescription={showItemDescription}
            getItemUrl={getItemUrl} />
        )
      }
    </div>
  )
}

Category.propTypes = {
  items: PropTypes.object,
  itemIds: PropTypes.array,
  mostViewedItemId: PropTypes.number,
  themeColorHex: PropTypes.string,
  isLoading: PropTypes.bool,
  hasMorePages: PropTypes.bool,
  onNextPage: PropTypes.func,
  onItemClick: PropTypes.func,
  gatingEnabled: PropTypes.bool,
  showViews: PropTypes.bool,
  showLikes: PropTypes.bool,
  shouldFetchNextPage: PropTypes.bool,
  showItemDescription: PropTypes.bool,
  showHomeCategory: PropTypes.bool,
  categories: PropTypes.object,
  categoryIds: PropTypes.array,
  selectedCategoryId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  onCategoryClick: PropTypes.func,
  getItemUrl: PropTypes.func.isRequired
}

export default Category
